/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_Too_Few_PlayersInputs */



/**
* | output |
* | --- |
* | "fewer than 10 players" |
*
* @param {Twda_Reason_Too_Few_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_too_few_players = /** @type {((inputs?: Twda_Reason_Too_Few_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_Too_Few_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("moins de 10 joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("menos de 10 jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("menos de 10 jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("meno di 10 giocatori")
	return /** @type {LocalizedString} */ ("fewer than 10 players")
});